import { Component, Inject, OnInit, Optional, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { PershingTranslationService } from '@pershing/pershing-core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'portfolio-splash',
  templateUrl: './splash.component.html'
})
export class SplashComponent implements OnInit {
  
  @ViewChild('videoIframeTemplate') videoTempalte: TemplateRef<any>;
  videoUrl: any;
  imageUrl: string;
  deviceType: string;
  constructor(sanitizer: DomSanitizer, 
    private dialog: MatDialog,
    private translationService: PershingTranslationService,
    @Optional() @Inject('AppSettings') appSettings: any,
    private router: Router,
    private location : Location
    ) { 
    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    this.videoUrl = sanitizer.bypassSecurityTrustResourceUrl(appSettings.ibdConfigMap.splashVideoUrl);
    this.imageUrl = appSettings.ibdConfigMap.cdnURL + '/staticartifacts/@pershing/nxi-branding@'+appSettings.angularBrandVersion+'/assets/images/conservative/brands/tdwealth/';
    this.deviceType = appSettings.deviceType;
  }
   
  ngOnInit() {
  }

  openDialog(){
    this.dialog.open(this.videoTempalte, {
      height: '85vh',
      width: '90vw'
   });
  }
  navigateToMixinPage(programCode){
    this.router.navigateByUrl('/nxi/digital-advise-mixin?progCode='+programCode);
  }

  goToPrevPage(event?){
    if(event){
      if(event.keyCode == 13 || event.keyCode == 32){
        this.location.back();
      }
    }
    else{
    this.location.back();
    }
  }

}
